module.exports = __webpack_public_path__ + "assets/img/4c29e68443dde4a210a983c019e873c7.png";